import React from "react";
import { CertifierBulkActionsTemplate } from "themes/application/certifier/components";
import { observer } from "mobx-react";

const CertifierBulkActions = observer(function CertifierBulkActions(props) {
    return <CertifierBulkActionsTemplate {...props} />;
});

export default CertifierBulkActions;
